// extracted by mini-css-extract-plugin
export default {"charityItem":"CharityItem_charityItem__7XCgT","thumb":"CharityItem_thumb__xHlt3","content":"CharityItem_content__FRCtR","title":"CharityItem_title__uLNp9"};